import { useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'
import { isEmpty } from 'ramda'
import {
  Box,
  ButtonIcon,
  IconClose,
  IconGift,
  ResponsiveRender,
  Text,
  TextLink
} from '@machobear/design-system'

import useCurrentSession from '@/hooks/use-current-session'
import useLocalStorage from '@/hooks/use-localstorage'
import useRole from '@/hooks/use-role'

import { BannerStyle } from './index.css'

type BannerProps = {
  position?: 'absolute' | 'relative' | 'fixed'
}

export const PromotionBanner = ({ position }: BannerProps) => {
  const [visible, setVisible] = useState(true)
  const [isClient, setIsClient] = useState(false)
  const [displayedBefore, setDisplayedBefore] = useLocalStorage(
    'promotion-banner-dismissed',
    false
  )
  const isTenant = useRole() === 'tenant'

  const { t } = useTranslation()
  const session = useCurrentSession()

  const closeBanner = () => {
    setVisible(false)
    setDisplayedBefore(true)
  }

  useEffect(() => {
    setIsClient(true)
  }, [])

  if (
    displayedBefore === undefined ||
    displayedBefore ||
    !visible ||
    isEmpty(session) ||
    !isClient ||
    isTenant
  )
    return null

  return (
    <Box className={BannerStyle} position={position ?? 'fixed'}>
      <Box
        width="full"
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        flexWrap="wrap"
        gap="xxsmall"
        role="status"
      >
        <ResponsiveRender above="mobile">
          <Text
            tone="neutralInverted"
            align="center"
            size="standard"
            weight="strong"
          >
            <IconGift tone="brandAccent" />
            {'   '}
            <TextLink
              href="/landlords/promotions"
              target="_blank"
              weight="weak"
              id="bf-banner"
            >
              {t(
                'LANDLORDS, SAVE UP TO 40% ON OUR MOST POPULAR TOOLS THIS HOLIDAY'
              )}
            </TextLink>
          </Text>
        </ResponsiveRender>
        <ResponsiveRender below="tablet">
          <Text
            tone="neutralInverted"
            align="center"
            size="standard"
            weight="strong"
          >
            <TextLink
              href="/landlords/promotions"
              target="_blank"
              weight="weak"
              id="bf-banner"
            >
              {t('SAVE UP TO 40% ON OUR MOST POPULAR LANDLORD TOOLS')}
            </TextLink>
          </Text>
        </ResponsiveRender>
        <Box
          position={position ? 'absolute' : 'fixed'}
          style={{ right: position ? '-55px' : '24px' }}
        >
          <ButtonIcon
            id="banner-close"
            label="close"
            icon={<IconClose tone="neutralInverted" />}
            onClick={closeBanner}
            variant="transparent"
          />
        </Box>
      </Box>
    </Box>
  )
}
